import isReallyDm from "./isReallyDm";

const isDm = state => {
    if (!isReallyDm(state)) {
        return false; // if you aren't really a dm, you can't pretend
    }
    const emulatePlayer = state.emulatePlayer;
    return typeof emulatePlayer !== "boolean" || !emulatePlayer;
};

export default isDm;



// WEBPACK FOOTER //
// ./src/selectors/isDm.js